<template>
  <div class="home">
    <div class="header">
      <div class="router-list">
        <span @click="routeHandle('home')">
          <i class="el-icon-s-home"></i>
        </span>
        <div v-for="(item, idx) in brandRoute" :key="idx">
          <span v-if="current.endsWith(item)" class="no-click">/{{ item }}</span>
          <span v-else @click="routeHandle(item)" class="click">
            /{{ item }}
          </span>
        </div>
        <div>
          <span class="page-count"> 总文件数: {{ page.total }}</span>
        </div>
      </div>
      <div class="handle">
        {{ user.name }}</el-span><el-button @click="event">退出</el-button>
      </div>
      <div class="input-form">
        <el-input v-model="search_key" class="input-search" placeholder="输入查询内容" clearable @change="search"></el-input>
        <el-button @click="search" class="input-search-btn" icon="el-icon-search">查询</el-button>
      </div>
      <div>
        <el-button @click="uploadBox" type="primary" icon="el-icon-upload">上传文件</el-button>
        <el-button @click="createDir" type="success" icon="el-icon-folder">添加文件夹</el-button>
        <el-button @click="deleteBox" type="danger" icon="el-icon-delete">删除文件</el-button>
      </div>
    </div>
    <div class="main">
      <div class="slide">
        <div v-for="item in path_list" :key="item.title" class="list-dir">
          <div class="path-value" :class="[item.title == curHome ? 'active' : '']" @click="toggleDir(item)">
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="table-Data">
        <PartUploder :current="current" v-on:uploadFile="uploadFile" />
        <div class="dir-name">
          <div class="dir-title">当前目录: {{ current_list }}</div>
          <div class="paginate">
            <el-pagination background @current-change="getPage" :current-page="page.current_page" :page-size="page.per_page" layout="prev, pager, next" :total="page.total">
            </el-pagination>
          </div>
        </div>
        <div class="list-table">
          <el-table :data="data" border stripe @selection-change="selectEle" ref="tableData" highlight-current-row>
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="文件名">
              <template slot-scope="scope">
                <span v-if="scope.row.is_today" class="new-hot">
                  <el-tag type="danger">New</el-tag>
                </span>
                <span class="handle-image" @click="handleFile(scope.row)">{{
                  scope.row.filename
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="extend" label="文件类型"></el-table-column>
            <el-table-column prop="size" label="文件大小"></el-table-column>
            <el-table-column label="修改时间">
              <template slot-scope="scope">
                {{ parseTime(scope.row.modify_time) }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.is_dir" @click="DownloadFile(scope.row)" size="mini" icon="el-icon-download">下载文件</el-button>
                <!--
                                <template v-if="scope.row.is_order">
                                    <el-button v-if="scope.row.is_dir" type="success" disabled>已生成订单</el-button>
                                </template>
                                <template v-else>
                                    <el-button v-if="scope.row.is_dir" type="danger" @click="confirmOrder(scope.row)">生成订单</el-button>
                            </template>
                                    -->
              </template>
            </el-table-column>
          </el-table>
          <div class="paginate">
            <el-pagination background @current-change="getPage" :current-page="page.current_page" :page-size="page.per_page" layout="prev, pager, next" :total="page.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-button id="scrollme" @click="scrollTop" icon="el-icon-top">回到顶部</el-button>
    <el-dialog :title="uploadTitle" :visible.sync="showUpload" width="40%" top="5px" :before-close="closeUpload">
      <el-upload class="upload-box" drag :action="action" list-type="picture" :headers="header" ref="upload" :on-success="uploadSuccess" :on-error="uploadFail" multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处</div>
      </el-upload>
    </el-dialog>
    <el-dialog :title="deleteTotal" :visible.sync="deleteBoxp" width="40%" top="5px" :before-close="deleteClose">
      <div class="limit-height">
        <div v-for="item in pendingDelete" :key="item.filename" class="pending-delete-list">
          <span>{{ item.filename }}</span>
          <i class="el-icon-delete" @click="removeFile(item.filename)"></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearDelete">取 消</el-button>
        <el-button type="primary" @click="deleteFile">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="80%" :visible.sync="showImage" top="1px" :before-close="showImageClose">
      <div class="show-image">
        <img :src="image" />
      </div>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="showForm" title="添加目录">
      <div class="show-image">
        <el-input v-model="form.path" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearDelete">取 消</el-button>
        <el-button type="primary" @click="confirmCreate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import PartUploder from "@/components/PartUploader";
export default {
  components: {
    PartUploder,
  },
  name: "Home",
  created() {
    this.base = this.$route.query.path;
    this.dir_name = this.$route.query.title;
    // this.getFile({ path: this.base, page: this.current_page });
    //this.addScrollListener()
    this.refresh();
    this.header = {Authorization: localStorage.getItem("token")}
    this.user = JSON.parse(localStorage.getItem("user"))
    console.log(this.user.name)
        
      
  },
  data() {
    return {
      user:{},
      data: [],
      form: {},
      action: "",
      dir_name: "",
      base: "/Users/yeyong/test",
      current: "",
      showUpload: false,
      deleteBoxp: false,
      pendingDelete: [],
      page: { total: 0 },
      search_key: "",
      image: "",
      showImage: false,
      type: "",
      deleteTotal: "",
      uploadTitle: "",
      successCount: 0,
      failCount: 0,
      isLoadImage: false,
      header: {
        Authorization: localStorage.getItem("token"),
      },
      path_list: JSON.parse(localStorage.getItem("list") || "{}"),
      current_list: localStorage.getItem("current") || "",
      showForm: false,
    };
  },
  computed: {
    brandRoute() {
      let base_len = (this.base || "").split("/").length;
      let cur = (this.current || "").split("/");
      return cur.slice(base_len, cur.length);
    },
    PageEleCount() {
      let cnt = this.page.current_page * this.page.per_page;
      if (cnt > this.page.total) {
        return this.page.total;
      }
      return cnt;
    },
    curHome() {
      return (this.$route.query.title || "").split("/")[0];
    },
  },
  watch: {
    $route(to, from) {
      // this.$router.go()
      // console.log("watch $route:", to, from);
      this.refresh();
    },
  },
  methods: {
    refresh() {
      this.base = this.$route.query.path || "";
      this.dir_name = this.$route.query.title;
      // console.log("log reated watch:", this.$route.query);
      this.getFile({ path: this.base, page: this.current_page });
    },
    event() {
      MessageBox.confirm("登录", "确认退出?", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((e) => {
          this.logout();
        })
        .catch(() => {
          //
        });
    },
    logout() {
        this.$store
          .dispatch("logout")
          .then(() => {
            localStorage.clear();
            this.$router.replace("/login");
          })
          .catch(() => {});

      // this.$confirm("确认退出么？", { type: "warning" }).then(() => {
      //   this.$store
      //     .dispatch("logout")
      //     .then(() => {
      //       localStorage.clear();
      //       this.$router.replace("/login");
      //     })
      //     .catch(() => {});
      // });
    },


    confirmOrder(item) {
      MessageBox.confirm("确认生成订单吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.generateOrder(item);
        })
        .catch(() => {
          return;
        });
    },
    uploadFile(e) {
      if (e.code == 200 && e.message == "文件合并完成") {
        this.data.unshift(e.data);
      }
    },
    generateOrder(item) {
      let path = `${this.current}/${item.filename}`;
      this.$api.getDir({ path: path }).then((res) => {
        if (res.data.length < 1) {
          MessageBox.confirm(
            "该目录下暂时没有文件, 请先上传文件再生成订单",
            "提示",
            {
              type: "warning",
            }
          );
          return;
        }
        this.$api
          .createOrder({ path: path, name: item.filename })
          .then((res) => {
            console.log(res);
          });
      });
    },
    showImageClose(e) {
      this.image = "";
      this.showImage = false;
    },
    createDir() {
      this.showForm = true;
    },
    loadImage(e) {
      let current = this.current + `/${e.filename}`;
      if (e.extend == "pdf") {
        let tmp = e.filename.split("-");
        let name = e.filename.replace("pdf", "jpg");
        if (tmp.length > 3) {
          name = tmp.slice(0, 2).join("-") + ".jpg";
        }
        current = "/www/data/User/Nicole/home/产品图/" + name;
      }

      return `${process.env.VUE_APP_BASE_API}${current}?download=true`;
    },
    deleteClose(e) {
      this.deleteTotal = "删除文件";
      this.deleteBoxp = false;
    },
    lazyLoadImage() {
      let toTop = this.$refs.loadImage;
      if (!toTop) {
        return;
      }
      let clientHeight = document.documentElement.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      if (toTop.offsetTop - scrollTop - clientHeight <= 100) {
        this.isLoadImage = true;
      }
    },
    addScrollListener() {
      let self = this;
      document.addEventListener("scroll", self.lazyLoadImage);
    },
    closeUpload(e) {
      this.showUpload = false;
      this.successCount = 0;
      this.failCount = 0;
      this.$refs.upload.clearFiles();
    },
    uploadSuccess(res, file, filelist) {
      if (res.code == 200) {
        let exist = this.data.filter((i) => i.filename == file.name);
        this.successCount += 1;
        this.uploadTitle = `文件上传, 成功${this.successCount}个, 失败: ${this.failCount}个`;
        if (exist.length > 0) {
          return;
        }
        this.data.unshift(res.data);
      }
    },
    uploadFail(err, file, filelist) {
      MessageBox(err);
      this.failCount += 1;
    },
    getPage(e) {
      this.getFile({ path: this.current, page: e }, true);
    },
    scrollTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    search() {
      if (!this.search_key) {
        this.getFile({ path: this.current });
        return;
      }
      this.search_key = this.search_key;
      this.$api
        .getDir({ path: this.current, key: this.search_key, search: true })
        .then((res) => {
          if (res.code == 200 && res.data.length > 0) {
            this.data = res.data;
            this.page = res.page;
          } else {
            MessageBox("未匹配到数据");
            return;
          }
        });
    },
    selectEle(e) {
      this.pendingDelete = e;
    },
    toggleDir(item) {
      this.current_list = item.title;
      //   this.getFile({ path: item.path, page: 0 });
      this.$router.push({
        name: "home",
        query: { path: item.path, title: item.title },
      });
    },
    getFile(parmas = {}, concat = false) {
      if (parmas.show) {
        this.showImage = true;
        this.image = parmas.path;
        return;
      } else {
        this.current = parmas.path;
        this.action = `${process.env.VUE_APP_BASE_API}${parmas.path}`;
      }
      this.$api.getDir(parmas).then((res) => {
        this.data = res.data || [];
        this.page = res.page || { total: 0 };
      });
    },
    uploadBox(e) {
      this.showUpload = true;
      this.uploadTitle = "上传文件";
    },
    deleteFile(e) {
      this.pendingDelete.forEach((w) => {
        let path = `${this.current}/${w.filename}`;
        this.$api.deleteFile(path).then((res) => {
          if (res.code == 200) {
            this.removeFile(w);
            let idx = this.data.findIndex((t) => t.filename == w.filename);
            this.data.splice(idx, 1);
          }
        });
      });
      this.deleteBoxp = false;
    },
    confirmCreate() {
      let err = false;
      this.data.forEach((i) => {
        if (i.filename == this.form.path) {
          err = true;
        }
      });
      if (err) {
        MessageBox.alert("该目录已经存在", "提示", {
          type: "error",
        });
        return;
      }
      this.$api
        .createDir({ path: `${this.current}/${this.form.path}` })
        .then((res) => {
          this.showForm = false;
          let h = { extend: "-", is_dir: true, filename: this.form.path };
          this.data.unshift(h);
          this.form = {};
        });
    },
    clearDelete() {
      this.deleteBoxp = false;
      this.form = {};
      this.showForm = false;
      this.$refs.tableData.clearSelection();
    },
    deleteBox(e) {
      if (this.pendingDelete.length <= 0) {
        this.$confirm("选择要删除的文件", "提示", { type: "warning" })
          .then((res) => {})
          .catch((err) => {});
        // MessageBox({
        //   title: "提示",
        //   message: "选择要删除的文件",
        //   type: "warning",
        // });
        return;
      }
      this.deleteBoxp = true;
      this.deleteTotal = `删除${this.pendingDelete.length}个文件`;
    },
    routeHandle(item) {
      if (item == "home") {
        this.$router.push({ path: "/" });
      }
      let temp = (this.current || "").split("/");
      let base = (this.base || "").split("/");
      let idx = temp.findIndex((w) => w == item);
      if (idx > -1) {
        let path = temp.slice(0, idx + 1);
        let current = path.join("/");
        if (path.length <= base.length) {
          current = this.base;
        }
        this.getFile({ path: current });
      } else {
        this.getFile({ path: this.base });
      }
    },
    handleFile(e) {
      let current = this.current + `/${e.filename}`;
      const { title } = this.$route.query;
      this.current_list = `${title}/${e.filename}`;
      //   this.current_list = this.current_list + "/" + e.filename;
      if (e.is_dir) {
        this.$router.push({
          name: "home",
          query: { path: current, title: this.current_list },
        });
        // this.getFile({ path: current });
      } else {
        this.type = e.extend;
        current = this.loadImage(e);
        this.getFile({ path: current, show: true });
      }
    },
    DownloadFile(e) {
      let current = this.current + `/${e.filename}?download=true`;
      let url = `${process.env.VUE_APP_BASE_API}${current}`;
      window.open(url);
    },
    removeFile(fn) {
      let idx = this.pendingDelete.findIndex((w) => w.filename == fn);
      this.pendingDelete.splice(idx, 1);
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      if (!time) {
        return "--";
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (typeof time === "string" && /^[0-9]+$/.test(time)) {
          time = parseInt(time);
        }
        if (typeof time === "number" && time.toString().length === 10) {
          time = time * 1000;
        }
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
          return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
  },
};
</script>
<style scoped>
.home {
  height: 92vh;
}
.img-load {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.new-hot {
  margin: 0px 12px 0 0;
}
.img-load img {
  width: 120px;
}
#scrollme {
  position: fixed;
  bottom: 200px;
  right: 0;
  z-index: 1000;
}
.limit-height {
  height: 400px;
  overflow-y: scroll;
  position: relative;
}
.handle-image {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.upload-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.el-upload {
  display: block;
}
.pending-delete-list {
  border-bottom: 1px solid #f2f2f2;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid #f2f2f2;
  padding: 12px;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 99%;
  background: #fff;
}
.table-Data {
  width: 88%;
  box-sizing: border-box;
  padding: 12px 18px;
}
.router-list,
.input-form {
  display: inline-flex;
  /* flex-direction: row; */
  font-size: 22px;
}
.no-click {
  color: #ccc;
}
.click {
  cursor: pointer;
  text-decoration: underline;
}
.show-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.show-image img {
  width: 100%;
  height: 100%;
}
.page-count {
  font-size: 18px;
  margin-left: 18px;
}
.dir-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  /* background: #fff; */
  margin: 12px 0;
}
.dir-title {
  font-size: 18px;
  padding: 4px;
  box-sizing: border-box;
  /* background: #fff; */
}
.paginate {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 12px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.upload-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.el-upload {
  display: block;
}
.pending-delete-list {
  border-bottom: 1px solid #f2f2f2;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border: 1px solid #f2f2f2;
  padding: 15px;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  /* height: 120px; */
  /* line-height: 120px; */
  background: #fff;
  box-sizing: border-box;
}
.table-Data {
  width: 88%;
  box-sizing: border-box;
  padding: 12px 18px;
}
.router-list,
.input-form {
  display: flex;
  flex-direction: row;
  font-size: 22px;
}
.no-click {
  color: #ccc;
}
.click {
  cursor: pointer;
  text-decoration: underline;
}
.show-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.show-image img {
  width: 100%;
  height: 100%;
}
.page-count {
  font-size: 18px;
  margin-left: 18px;
}
.dir-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* padding: 5px 12px; */
}
.dir-title {
  font-size: 18px;
  box-sizing: border-box;
}
.paginate {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 12px;
}
.el-upload-list {
  padding: 5px;
  width: 400px;
  max-height: 400px;
  overflow-y: scroll;
}
.main {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 72px;
  box-sizing: border-box;
  /* border: 1px dashed red; */
  background: rgba(244, 252, 255, 1);
}
.slide {
  width: 12%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  line-height: 36px;
  font-size: 16px;
}
.list-table {
}
.list-dir {
  width: 100%;
}
.path-value {
  border-bottom: 1px solid #e7e7eb;
  box-sizing: border-box;
  padding: 12px;
  cursor: pointer;
  text-align: center;
  background: rgba(18, 35, 65, 1);
  color: rgba(148, 244, 255, 1);
}
.active {
  color: rgba(18, 35, 65, 1);
  background: transparent;
  position: relative;
}
.active::before {
  content: " ";
  position: absolute;
  z-index: 100;
  left: 5px;
  top: 10%;
  background: #122341;
  display: block;
  height: 80%;
  width: 6px;
  border-radius: 3px;
}
.input-search {
  margin-right: 10px;
}
</style>
<style>
body {
  margin: 0;
}
.input-search .el-input__inner {
  border-radius: 36px;
  min-width: 420px;
}
.input-form .el-button {
  border-radius: 36px;
}
.input-form .input-search-btn {
  background-color: rgba(35, 75, 89, 1);
  border-color: rgba(35, 75, 89, 1);
  color: white;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #234b59 !important;
  border-color: #234b59 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #234b59 !important;
}
</style>